<!-- Alert  -->
@if (message && displayAlert) {
  <div [ngClass]="cssClass" [style.margin-bottom]="marginBottom" [style.margin-top]="marginTop" class="alert-message size-{{ size }}">
    <div class="flex-row-start-center">
      <div class="main-alert__icon">
        <app-icon [color]="iconColor" [iconName]="iconName" size="20px"></app-icon>
      </div>
      <div class="alert-message__title ml-10">
        @if (message) {
          <h5 translate>{{ message }}</h5>
        }
        @if (detailMessage) {
          <small>{{ detailMessage }}</small>
        }
        @if (denyReason) {
          <p>
            <b>{{ 'Deny Reason' | translate }}:</b> {{ denyReason }}
          </p>
        }
      </div>
    </div>
    @if (showCloseIcon) {
      <div class="alert-message__close">
        <app-icon (click)="closeAlert()" [color]="iconColor" [ngStyle]="{ cursor: 'pointer' }" iconName="close" size="20px"></app-icon>
        <!--  THis below button is commented out as it may be required in future updates -->
        <!--<app-button cssClass="button-secondary" size="xs" [idleText]="'OK'"></app-button>-->
      </div>
    }
  </div>
}
